import React, { useMemo } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { Typography } from 'antd'

import { PRIVATE_ROUTES } from '../../routes'
import {
    MarketXToolbarProvider,
    useMarketXToolbarSlot,
} from './MarketXToolbar'
import styles from './marketx.module.css'

const { Title } = Typography

const isInspirationListPath = (pathname) => {
    const normalized = pathname.replace(/\/$/, '') || pathname
    return (
        normalized === PRIVATE_ROUTES.inspirationGallery.root ||
        normalized === `${PRIVATE_ROUTES.marketx}/inspiration-gallery`
    )
}

const MarketXLayoutInner = () => {
    const toolbar = useMarketXToolbarSlot()
    const { pathname } = useLocation()

    const isListPage = useMemo(
        () => isInspirationListPath(pathname),
        [pathname]
    )

    return (
        <div className={styles.pageContainer}>
            <div
                className={styles.pageHeader}
                style={isListPage ? undefined : { display: 'none' }}
            >
                <div className={styles.headerBar}>
                    <Title level={3} className={styles.pageTitle}>
                        Inspiration Gallery
                    </Title>
                    <div
                        ref={toolbar?.setSlotEl}
                        className={styles.tabsExtra}
                    />
                </div>
            </div>

            <div className={styles.moduleBody}>
                <Outlet />
            </div>
        </div>
    )
}

const MarketXLayout = () => (
    <MarketXToolbarProvider>
        <MarketXLayoutInner />
    </MarketXToolbarProvider>
)

export default MarketXLayout
